import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Icon } from 'antd'
import { app, api, config } from '../../../../app'

import html2canvas from 'html2canvas';



class LetterUndertaking extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let d1 = ''
        let d2 = ''
        let uploadImgList = []
        let whiteOK = false
        // console.log(props)
        if(props.fileInfo.length <=0){

        }else if(props.fileInfo[3].data != undefined){
            if (props.fileInfo[3].data.d1 != undefined) {
                d1 = props.fileInfo[3].data.d1
                d2 = props.fileInfo[3].data.d2
    
                whiteOK = true
                let data = {
                    d1: d1,
                    d2: d2,
    
                }
                this.props.credit_file_json(data, 'data')
                if (props.fileInfo[3].img != undefined && props.fileInfo[3].img != '') {
                    uploadImgList = props.fileInfo[3].img.split(';;;')
                    this.props.credit_file_json(uploadImgList, 'img')
                }
            }
        } 
        

        if (props.com3.data != undefined) {
            d1 = props.com3.data.d1
            d2 = props.com3.data.d2
            if (props.com3.img != '') {
                uploadImgList = props.com3.img.split(';;;')
            }
        }

        this.state = {
            fileInfo: props.fileInfo,   //初始数据，一进入组件就请求获得

            isModalVisible: false,
            isModalVisible2: false,
            whiteModal: false,

            LetterUndertakingImg: '',
            d1: d1,
            d2: d2,
            defaultImgList: [],

            uploadImgList: uploadImgList,
            showMoadlImg: '',
            imgModal: false,
            whiteOK: whiteOK,  //是否已经提交过内容
            whiteModal: false,    //是否打开 注册申请表 编辑窗口

        }

    }

    componentDidMount() {
        this.getDefaultImg()
        this.getExamineInfo()
        this.getApplyinfo()
    }



    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            if (this.props.apply != 1) {
                return
            }
            // 值发生改变下一步工作
            const applyinfo = app.getData('applyinfo');

            let uploadImgList = this.state.uploadImgList;
            this.props.credit_file_json(applyinfo.file[3].data, 'data')

            uploadImgList = applyinfo.file[3].img.split(';;;')
            this.props.credit_file_json(uploadImgList, 'img')

            this.setState({
                uploadImgList,
                d1: applyinfo.file[3].data.d1,
                d2: applyinfo.file[3].data.d2,
                whiteOK: true
            })

        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            if (this.props.examine != 1) {
                return
            }
            const examineInfo = app.getData('examineInfo');
            let uploadImgList = this.state.uploadImgList;
            uploadImgList = examineInfo.file[3].img.split(';;;')
            this.setState({
                uploadImgList
            })
        }
    }

    //对默认展示图片进行处理
    getDefaultImg = () => {
        if(this.props.fileInfo.length <= 0){
            return
        }
        let defaultImgList = this.props.fileInfo[3].template_img.split(';;;')
        // console.log(defaultImgList)
        this.setState({
            defaultImgList
        })
    }


    getExamineInfo = () => {
        if (this.props.examine != 1) {
            return
        }
        const examineInfo = this.props.examineInfo;
        let uploadImgList = this.state.uploadImgList;
        uploadImgList = examineInfo.file[3].img.split(';;;')
        this.setState({
            uploadImgList
        })
    }

    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        const applyinfo = this.props.applyinfo;
        let uploadImgList = this.state.uploadImgList;
        this.props.credit_file_json(applyinfo.file[3].data, 'data')

        uploadImgList = applyinfo.file[3].img.split(';;;')
        this.props.credit_file_json(uploadImgList, 'img')

        this.setState({
            uploadImgList,
            d1: applyinfo.file[3].data.d1,
            d2: applyinfo.file[3].data.d2,
            whiteOK: true
        })
    }

    showModal = () => {
        this.setState({
            isModalVisible: true
        })
    }

    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    }







    submit = () => {
        const { d1, d2 } = this.state;
        if (d1 == '') {
            app.alert('申请人名称未填写', 'error', '45%')
            return
        }
        if (d2 == '') {
            app.alert('申请人身份证号码未填写', 'error', '45%')
            return
        }
        let data = {
            d1: d1,
            d2: d2,
        }
        this.props.credit_file_json(data, 'data')
        this.setState({
            whiteModal: false,
            whiteOK: true
        })
    }

    _changeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value.trim()
        })
    }

    ShutDownFill = () => {
        this.setState({
            whiteModal: false
        })
    }



    // {/* 存心救援队注册申请表 */}
    clickImg = (i) => {
        // console.log(i.target.getAttribute('data-img'))
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img')
        })
    };

    deleImg = (i) => {
        const { uploadImgList } = this.state;
        uploadImgList.splice(i, 1)
        // this.props.deleteImg_credit_file_json(i)
        this.props.credit_file_json(uploadImgList, 'img')

        this.setState({
            uploadImgList
        })
    };


    clickImgCencel = () => {
        this.setState({
            imgModal: false
        })
    };



    white = () => {

        this.setState({
            whiteModal: true
        })
    }

    closeWhite = () => {
        this.setState({
            whiteModal: false
        })
    }



    downLoad = (blobUrl) => {
        let data = {
            d1: this.state.d1,
            d2: this.state.d2,
        }
        let that = this;
        let xhr = new XMLHttpRequest()
        xhr.open('POST', config.serverUrl + '/TeamPrep/getFilePdf', true)
        xhr.responseType = 'blob'
        let fd = new FormData();
        fd.append("key", 'credit');
        fd.append("file_data", JSON.stringify(data));
        xhr.send(fd);
        xhr.onload = function () {
            if (this.status == 200) {
                let blob = this.response
                console.log(blob)
                that.downloadFile1(blob, 'pdf', '征信承诺书.pdf');
            }
        }
    }

    downloadFile1(data, type, fileName) {
        let blob = new Blob([data], { type: `application/${type};charset=utf-8` });
        console.log(123)
        // 获取heads中的filename文件名
        let downloadElement = document.createElement('a');
        // 创建下载的链接
        let href = window.URL.createObjectURL(blob);
        downloadElement.href = href;
        // 下载后文件名
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        // 点击下载
        downloadElement.click();
        // 下载完成移除元素
        document.body.removeChild(downloadElement);
        // 释放掉blob对象
        window.URL.revokeObjectURL(href);
    }


    uploadImg = (info) => {
        if(info.file.status === 'uploading'){
            let flag = true
            this.props.uploadImgLoading(flag)
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                // console.log(res)
                app.alert(res.msg, 'success', '45%')
                // 将数据返回给父组件

                // let img = res.data.url;
                // this.props.credit_file_json(img, 'img')
                const { uploadImgList } = this.state;
                uploadImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.props.credit_file_json(uploadImgList, 'img')

                this.setState({
                    uploadImgList
                },()=>{
                    let flag = false
                    this.props.uploadImgLoading(flag)
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }


    downloadJPG = async (DOMId, fileName) => {
        let ppg = document.getElementById(DOMId);

        html2canvas(ppg, {
            allowTaint: false,
            useCORS: true,
        }).then(canvas => {
            // toImage
            const dataImg = new Image()
            dataImg.src = canvas.toDataURL('image/png')
            const alink = document.createElement("a");
            alink.href = dataImg.src;
            alink.download = fileName + ".png";
            alink.click();
            this.setState({
                whiteModal: false
            })
        });
    }


    lastImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            //如果用户没有上传图片，那么点击图片预览的是模版图片
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = defaultImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            //如果用户上传了图片，那么点击图片预览的是上传图片
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 0) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 0) {
                return
            } else {
                showMoadlImg = uploadImgList[index - 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }

    nextImg = () => {
        let showMoadlImg = this.state.showMoadlImg;
        const { uploadImgList, defaultImgList } = this.state;
        let index
        if (uploadImgList.length < 1) {
            defaultImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == defaultImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == defaultImgList.length - 1) {
                return
            } else {
                showMoadlImg = defaultImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        } else {
            uploadImgList.forEach((i, v) => {
                if (i == showMoadlImg) {
                    if (v == 2 || v == uploadImgList.length - 1) {
                        index = v
                        app.alert("没有更多图片了", 'error', '45%')
                        return
                    } else {
                        index = v
                    }
                }
            })
            if (index == 2 || index == uploadImgList.length - 1) {
                return
            } else {
                showMoadlImg = uploadImgList[index + 1]
                this.setState({
                    showMoadlImg
                })
            }
        }


    }





    // 页面渲染区
    render() {
        let { fileInfo, LetterUndertakingImg, uploadImgList, d1, d2, defaultImgList } = this.state
        const content = (
            <div>
                <p>点击可预览模板</p>
            </div>
        )

        const imgList = uploadImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' :
                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>
                        }
                    </div>
                }>

                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>

            )
        })

        const defaultImg = defaultImgList.map((item, index) => {
            return (
                <Popover key={item} content={
                    <div >
                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览模板</p>
                    </div>
                }>
                    <img style={{ width: 90, height: 100, marginRight: 5 }} key={item} src={config.imgUrl + item} alt="" />
                </Popover>



            )
        })

        return (
            <div >
                <div style={{ width: 400, height: 200, borderWidth: 1, borderStyle: 'solid', borderColor: '#000' }}>
                    {/* 标题 */}
                    <p style={{ fontSize: 16, color: '#1890FF', paddingTop: 15, paddingLeft: 10 }}>
                        <Popover content={content}>
                            <span style={{ cursor: 'pointer' }} onClick={this.showModal}>《征信承诺书》</span>
                        </Popover>

                        <Modal title="征信承诺书" visible={this.state.isModalVisible} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.handleCancel}>

                            {
                                defaultImgList.map((item, index) => {
                                    return (

                                        <img style={{ width: 1150, marginRight: 5,borderBottom:3,borderBottomStyle:'solid',borderBottomColor:'#ddd' }} key={item} src={config.imgUrl + item} alt="" />

                                    )
                                })
                            }
                        </Modal>
                    </p>
                    {/* 标题end */}

                    {/* 资料框 */}
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-around', width: '80%' }}>

                            <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3 }}>
                                {
                                    uploadImgList.length < 1
                                        ?
                                        defaultImg
                                        :
                                        imgList
                                }

                            </div>


                            <Modal title="征信承诺书" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                                <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                                        <Icon type="left" ></Icon> 上一张
                                    </div>
                                    <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                                        下一张<Icon type="right" ></Icon>
                                    </div>
                                </p>
                                {

                                    <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                                }
                            </Modal>


                        </div>
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : !this.state.whiteOK
                                ?
                                <div >
                                    <div style={{ cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>填写</div>
                                    <div style={{ marginTop: 5 }}>下载</div>
                                    <div style={{ marginTop: 5 }} >上传</div>
                                </div>
                                :
                                <div >
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.white}>编辑</div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} onClick={this.downLoad}>
                                        下载
                                        </div>


                                    {uploadImgList.length == 3
                                        ?
                                        <div style={{ marginTop: 5 }} >上传</div>
                                        :
                                        <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF' }} >
                                            <Upload
                                                accept='image/jpeg, image/jpg, image/png'
                                                showUploadList={false}
                                                action={config.serverUrl + "/TeamApply/imageUpload"}
                                                name="image"
                                                onChange={this.uploadImg}
                                                style={{ color: '#1890FF' }}>上传</Upload>
                                        </div>}




                                </div>

                        }

                    </div>
                    {/* 资料框 */}
                    <div style={{ width: 70, paddingLeft: 10, }}>
                        <Modal title="征信承诺书" visible={this.state.whiteModal} width={1250} footer={null} onCancel={this.ShutDownFill} style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ width: '100%', padding: 80, height: 1350, fontSize: 22 }} id="JPGDOM">
                                {/* 展示栏 */}
                                <p style={{ textAlign: 'center', fontSize: 34, }}>征信承诺书</p>

                                <p style={{ textIndent: '2em' }}>本人
                                    <input type="text"
                                        onChange={this._changeValue}
                                        name="d1" value={d1}
                                        style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid' }} />
                                    ，
                                    身份证号：
                                    <input type="text"
                                        onChange={this._changeValue}
                                        name="d2" value={d2}
                                        style={{ outline: 'none', border: 0, borderBottom: 1, textAlign: 'center', borderBottomColor: '#000', borderStyle: 'solid' }} /></p>

                                <p style={{ textIndent: '2em' }}>本人郑重承诺:</p>

                                <p style={{ textIndent: '2em' }}>一、本人所提供的材料内容均真实有效，并保证与对应原始文件一致；</p>

                                <p style={{ textIndent: '2em' }}>二、本人无违法犯罪、违约失信行为，社会声誉和信用情况良好；</p>

                                <p style={{ textIndent: '2em' }}>三、本人承诺，无故意隐瞒内容，并愿意承担上述材料真实性所带来的一切后果。</p>

                                <p style={{ textIndent: '25em', paddingTop: 300 }}>承诺人：<span style={{ color: '#ccc', fontSize: 16 }}>签名加盖手指印</span></p>

                                <p style={{ textIndent: '25em' }}>承诺日期：_______年_______月_______日</p>


                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.submit}>提交</Button>
                                <Button style={{ width: 200 }} onClick={this.ShutDownFill}>关闭</Button>
                                <div onClick={this.downloadJPG}></div>
                            </div>
                        </Modal>


                    </div>
                </div>
            </div>



        )
    }
}



export default LetterUndertaking



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/LetterUndertaking.jsx